import BottomNavigation from './Navigation';

export default BottomNavigation;
